import Swiper from 'swiper';
import 'swiper/css';

export default class FeatureList {
    constructor() {
        this.sections = document.querySelectorAll('.block-feature-list');
        this.ready();
    }

    ready() {
        if (this.sections.length > 0) {
            this.sections.forEach((section) => {
                this.slider = section.querySelector('.swiper');

                new Swiper(this.slider, {
                    grabCursor: false,
                    allowTouchMove: true,
                    slidesPerView: "auto",
                    spaceBetween: 12,
                    slidesOffsetAfter: 16,
                    slidesOffsetBefore: 16
                });

            })
        }
    }
}

if (document.querySelector('.block-feature-list')) {
    new FeatureList();
}